import { IndexProfileListItem } from "humboldt";
import * as React from "react";
import * as qs from "query-string";
import { connect } from "react-redux";
import { Dispatch } from "redux";
import { IAuthState } from "../../auth/model";
import { AppAction } from "../../root/actionTypes";
import * as actions from "../../root/actions";
import Divider from "../sfc/Divider/Divider";
import TileContent from "../sfc/tileContent";
import Title from "../sfc/title";

import { ProfileSelectionText } from "./constants";

interface IProfileSelectorProps {
    auth: IAuthState;
    action: (x: any) => any;
    dispatch: Dispatch<AppAction>;
    isLoading: boolean;
    profileList: IndexProfileListItem[];
    location: Location;
}

const RenderLoading: React.FunctionComponent<{ isLoading: boolean }> = ({ isLoading }) => {
    const returnVal = !isLoading ? null : (
        <div className="icon icon--order-success svg whereAreYou">
            <svg xmlns="http://www.w3.org/2000/svg" width="72px" height="72px">
                <g fill="none" stroke="#68CCDD" strokeWidth="2">
                    <circle
                        className="loading"
                        cx="36"
                        cy="36"
                        r="30"
                        style={{
                            strokeDasharray: "240px, 240px",
                            strokeDashoffset: "480px",
                        }}
                    />
                </g>
            </svg>
        </div>
    );
    return returnVal;
};

class ProfileSelector extends React.Component<IProfileSelectorProps> {
    componentDidMount() {
        const { dispatch, auth } = this.props;
        if (auth && auth.profile) {
            actions.getProfileListByUsername(dispatch, auth.profile.sub);
        }
    }

    public render() {
        const { location, isLoading, action, profileList } = this.props;
        const query = qs.parse(location.search);

        // Grabbing the value for the 'app' key in the url
        const device = String(query.app).replace("_", " ");
        const deviceString = device
            .split(" ")
            .map((string) => string.charAt(0).toUpperCase() + string.slice(1))
            .join(" ");

        return (
            <div className="WhereAreYou">
                <Title titleText={ProfileSelectionText.title} subtitle={ProfileSelectionText.desc(deviceString)} />
                <Divider color="#68ccdd" gap="10px" width="50px" />
                <RenderLoading isLoading={isLoading} />
                <TileContent action={action} profileList={profileList} />
            </div>
        );
    }
}

function mapStateToProps(state: any) {
    return {
        location: state.router.location,
        profileList: state.app.profileList,
        isLoading: state.app.isLoadingProfileList,
        auth: state.auth,
    };
}

function mapDispatchToProps(dispatch: any) {
    return { dispatch };
}

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(ProfileSelector);
